import { AsyncPipe, NgClass } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalClosed } from '@services/modal.service';
import { NotificationsService } from '@services/notifications.service';
import { ResponsiveService } from '@services/responsive.service';
import { Observable, Subscription } from 'rxjs';
import { CommonButtonComponent } from '../common-button/button.component';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { Notification, NotificationType } from './notification';

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [NgClass, AsyncPipe, SvgIconComponent, CommonButtonComponent],
  templateUrl: './notification.component.html',
})
export class NotificationComponent implements OnInit, OnDestroy {
  private _subscription?: Subscription;

  notifications: Notification[] = [];

  delay: Record<string, boolean> = {};

  isMobile$?: Observable<boolean>;

  constructor(
    public responsive: ResponsiveService,
    private _notificationService: NotificationsService,
  ) {
    this.isMobile$ = this.responsive.isMobile$();
  }

  private _addNotification(notification: Notification) {
    notification.style = this.getStyle(notification.type);
    this.notifications.push(notification);

    if (notification.timeoutMs !== 0) {
      setTimeout(() => this.close(notification), notification.timeoutMs);
    }

    if (notification.type === 5) {
      this.delay[notification.id] = true;

      setTimeout(() => {
        this.delay[notification.id] = false;
      }, 6000);
    }
  }

  ngOnInit() {
    this._subscription = this._notificationService.getObservable().subscribe((notification) => {
      if (notification && notification?.status !== 'close') {
        this._addNotification(notification as Notification);
      } else if (notification?.status === 'close') {
        // Lets a component dismiss one of ITS OWN earlier toasts by id (e.g. replacing "Still
        // Confirming Your Payment" with the final success/failure toast) - this previously did
        // nothing here; other subscribers to the same observable (e.g. AppComponent's token-consent
        // handling) still receive this event independently and are unaffected by this addition.
        const index = (notification as ModalClosed).index;
        this.notifications = this.notifications.filter((notif) => notif.id !== index);
      }
    });
  }

  ngOnDestroy() {
    this._subscription?.unsubscribe();
  }

  close(notification: Notification) {
    this.notifications = this.notifications.filter((notif) => notif.id !== notification.id);
  }

  confirm(notification: Notification) {
    this._notificationService.close(notification.id, 'confirm');
    this.close(notification);
  }

  getStyle(type: NotificationType) {
    const label = NotificationType[type >= 4 ? 1 : type];
    return {
      icon: `notification_${label}`,
      iconColor: `var(--accent-${label})`,
    };
  }
}
